namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailSchvalovaciSablonaEpkUkony extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GSchvalovaciSablonaEpkUkonyReadDto;
        private newRecord: boolean;
        private detailObj: DetailSchvalovaciSablonaEpkUkonyObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailSchvalovaciSablonaEpkUkonyObj());
            this.detailObj.createBase({
                contentName: "detailSchvalovaciSablonaEpkUkony",
                contentCaption: "jres:33000904",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailSchvalovaciSablonaEpkUkony", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction().done(() => { this.detailObj.removeTempFiles(); });
        }
    }


    export class DetailSchvalovaciSablonaEpkUkonyObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GSchvalovaciSablonaEpkUkonyReadDto> {
        private visualSignAllowed: boolean;
        private uploadVisualSignButtonName = "upload_file_visual_sign_class";
        private uploadVisualSignButton: JQuery<HTMLElement>;
        private HandVisualSignPosition: boolean;
        private tempVisualPosition: Gordic.Security.Service.GPdfVisualSignPositionDto;
        private badgeUmisteni: any;
        private guids: string[];

        create() {
            this.guids = [];
            if (this.options.newRecord == false) {
                this.badgeUmisteni = new GObservableObject({
                    id: "idHandVisualSignPositionBadge",
                    value: "",
                    tooltip: ""
                })
                this.badgeUmisteni.update();
                this.loadVisualSignPositionIfExist(this.data.ixs_ssa ?? "", this.data.radek_sab ?? 0)
                this.addButtonUploadFileForVisualSign();
            }
        }

        textPopis(): string | undefined | null {
            return `${this.data.ixs_ssa_txt} x ${this.data.radek_sab}`
        }

        setSxsDetail(): string {
            return `${this.data.ixs_ssa}#${this.data.radek_sab}#`;
        }

        saveData(data: Gordic.AdmIsl.Interface.GSchvalovaciSablonaEpkUkonySaveDto, close: boolean) {
            this.cnt.isl.SchvalovaciSablonaEpkUkony.upsert({ data: data }).get().then((output: any) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    });
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).catch((err) => {
                this.pendingAction("actSave", false)
                throw err;
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            this.openDetailOrModalWindow("Gordic.Adm.WebControls.DetailSchvalovaciSablonaEpkUkony", filterObj, dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.SchvalovaciSablonaEpkUkony.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.textPopis()}`
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                {
                    action: this.cnt.actions.actVisualSignPosition,
                    favorite: true,
                    badge: this.badgeUmisteni
                },
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actVisualSignPosition: {
                    icon: "fa-map-marker",
                    caption: "jres:32000151",
                    visible: this.options.newRecord == false && this.visualSignAllowed == true,
                    run: () => {
                        this.uploadVisualSignButton.find(".fa-cloud-upload").click()
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.form.form.layoutDescriptor = "L2M2S1";
            this.MakeSection("");
            this.MakeSelectField("ixs_ssa", Gordic.Prefabs.Select.wflsssa(), {
                model: "model.ixs_ssa=value.ixs_ssa",
                flag: this.createFlagNemenne()
            })
            this.MakeField("radek_sab", { flag: this.createFlagNemenne() })
            this.MakeSelectField("typ_pozad_pod", Gordic.Prefabs.Select.wflctpp(), { model: "model.typ_pozad_pod=value.typ_pozad_pod" })
            this.MakeField("typ_pozad_pod_pozn")
            this.MakeSelectField("ixs_sro", Gordic.Prefabs.Select.wflssro(), { model: "model.ixs_sro=value.ixs_sro" })
            this.MakeSelectField("sch_pov", Gordic.Prefabs.Select.wflcspu(), { model: "model.sch_pov=value.sch_pov" })
            this.MakeField("sch_uroven")
            this.MakeField("dnu_pozad")
            this.MakeSelectField("priz_den_poz_prac", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_den_poz_prac=value.priz_an" })
            this.MakeSelectField("priz_edit_termin", Gordic.Prefabs.Select.wflcpet(), { model: "model.priz_edit_termin=value.priz_edit_termin" })
            this.MakeSection("");
            this.MakeSelectField("priz_opak", Gordic.Prefabs.Select.wflcpok(), { model: "model.priz_opak=value.priz_opak" })
            this.MakeField("id_alg")
            this.MakeSelectField("priz_opa", Gordic.Prefabs.Select.wflcopa(), { model: "model.priz_opa=value.priz_opa" })
            this.MakeSelectField("ixs_dpo", Gordic.Prefabs.Select.wflsdpo(), { model: "model.ixs_dpo=value.ixs_dpo" })
            this.MakeSelectField("stav_schvproc", Gordic.Prefabs.Select.wflsstp(), { model: "model.stav_schvproc=value.stav_schvproc" })
            this.MakeSelectField("ixs_ssa_1", Gordic.Prefabs.Select.wflsssa(), { model: "model.ixs_ssa_1=value.ixs_ssa" })
            this.MakeSelectField("ixs_ssa_2", Gordic.Prefabs.Select.wflsssa(), { model: "model.ixs_ssa_2=value.ixs_ssa" })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        // Vizuální umístění podpisu

        private updateBadgeUmisteniPodpisu(handle: boolean) {
            const id = "idHandVisualSignPositionBadge";
            const value = "jres:32000155"; //RC 32000155 : Ručně
            const tooltip = "jres:32000156"; //RC 32000156 : Obsahuje ručně zadaný vizuální podpis

            if (this.badgeUmisteni == null) {
                this.badgeUmisteni = new GObservableObject({
                    id: id,
                    value: handle === true ? value : "",
                    tooltip: handle === true ? tooltip : ""
                })
            }
            else {
                this.badgeUmisteni.update({
                    id: id,
                    value: handle === true ? value : "",
                    tooltip: handle === true ? tooltip : ""
                });
            }
        }

        private loadVisualSignPositionIfExist(ixs_ssa: string, radek_sab: number) {
            if (ixs_ssa == null || radek_sab == null)
                return;
            this.cnt.isl.FutureSignaturePositionBinding.list({ filters: { ixs: ixs_ssa, por_cislo: radek_sab } }).getData()
                .then((data) => {
                    if (data != null && data.length > 0) {
                        let tempPorCislo = 0;
                        let tempValue: Gin.Interface.GFutureSignaturePositionBindingDto;
                        for (let index = 0; index < data.length; index++) {
                            var value = data[index];
                            if (value.por_cislo! >= tempPorCislo) {
                                tempPorCislo = value.por_cislo!;
                                tempValue = value;
                            }
                        }
                        return this.cnt.isl.SignaturePosition.read({ ixs_umi: tempValue!.ixs_umi }).getData();
                    }
                    else {
                        return $.Deferred().resolve(null).promise();
                    }
                })
                .then((position?: Gin.Interface.GSignaturePositionDto | null) => {
                    if (position != null) {
                        this.tempVisualPosition = this.contertVisualSignPositionDto(position);
                        this.HandVisualSignPosition = true;
                    }
                    this.updateBadgeUmisteniPodpisu(this.HandVisualSignPosition);
                })
        }

        private contertVisualSignPositionDto(pos: Gin.Interface.GSignaturePositionDto) {
            var result: Gordic.Security.Service.GPdfVisualSignPositionDto = {
                ID: pos.ixs_umi,
                X: pos.pozice_x,
                Y: pos.pozice_y,
                PageHeight: pos.strana_vyska,
                PageWidth: pos.strana_sirka,
                PageIndex: pos.strana,
                Height: pos.vyska,
                Width: pos.sirka
            }
            return result;
        }

        private addButtonUploadFileForVisualSign() {
            this.uploadVisualSignButton = $("<div style='display: none;'>").gfilefield({
                name: "uploadFileVisuanSignName",
                customClass: this.uploadVisualSignButtonName,
                maxFileCount: 3,
                fileUploaded: (ev, obj) => {
                    let target = $(ev.target);
                    if (obj.fileInfo != null && obj.fileInfo.filename != null && obj.fileInfo.guid != null) {
                        let filename = obj.fileInfo.filename;
                        let guid = obj.fileInfo.guid;
                        this.guids.push(guid);
                        if ((obj as any).fileInfo.file.type !== "application/pdf") 
                            this.cnt.dialogs.alert("jres:32000149", "jres:32000160"); //RC 32000160 : K této příloze nelze vložit umístění podpisu
                        else {
                            this.cnt.call("GetFile", { guid: guid })
                                .then((fileData) => {
                                    let flashErrorLabel = "jres:32000159"; //RC 32000159 : Vizuální podpis nebyl umístěn.
                                    let flashSuccessLabel = "jres:32000157"; //RC 32000157 : Byl umístěn nový vizuální podpis.
                                    this.cnt.navigate(Gordic.Adm.WebControls.GAdmSignPlacing, {
                                        data: {
                                            fileData: fileData,
                                            fileName: filename,
                                            signaturePositions: this.tempVisualPosition != null ? this.tempVisualPosition : null
                                        },
                                        sigSelectOptions: {
                                            drawingStyle: Gin.WebClient.GSignatureDrawingStyle.drawRectangle
                                        } as Gin.WebClient.IGSigSelectOptions
                                    }).on("contentclosed", (ev, signatures: any[]) => {
                                        if (signatures != null && signatures.length > 0) {
                                            let signature = signatures[0];
                                            if (this.tempVisualPosition != null) {
                                                //protože existuje temp, doplním ixs_umi, aby se zbytečně nevytvářelo nové
                                                signature.ID = this.tempVisualPosition.ID;
                                                flashSuccessLabel = "jres:32000158" //RC 32000158 : Umístění vizuálního podpisu bylo změněno.
                                            }
                                            // uložení pozic podpisu do tempu
                                            this.tempVisualPosition = signature;
                                            this.cnt.isl.FutureSignaturePositionBinding.setFutureSignaturePositionBinding({
                                                ixs: (this.data.ixs_ssa as any),
                                                ixsFun: "",
                                                porCislo: (this.data.radek_sab as any),
                                                position: signature
                                            })
                                                .getData().then(() => {
                                                    this.clearFileField(target);
                                                    this.HandVisualSignPosition = true;
                                                    this.updateBadgeUmisteniPodpisu(this.HandVisualSignPosition);
                                                    this.cnt.notification("showToast", {
                                                        title: this.textPopis() ?? "",
                                                        content: flashSuccessLabel,
                                                        state: "success",
                                                        icon: "fa-check-circle"
                                                    })
                                                })
                                                .fail(() => {
                                                    this.cnt.notification("showToast", {
                                                        title: this.textPopis() ?? "",
                                                        content: flashErrorLabel,
                                                        state: "error",
                                                        icon: "fa-times-circle"
                                                    })
                                                })
                                        }
                                        else {
                                            this.clearFileField(target);
                                            this.cnt.notification("showToast", {
                                                title: this.textPopis() ?? "",
                                                content: flashErrorLabel,
                                                state: "error",
                                                icon: "fa-times-circle"
                                            })
                                        }
                                    });
                                });


                        }

                    }

                },
            }).appendTo(this.cnt.element);

        }

        private clearFileField(element: JQuery<HTMLElement>) {
            element.findFields().gfield("clear");
        }

        removeTempFiles() {
            this.cnt.fire("RemoveTempFiles", { guids: this.guids });
        }
    }
}